import { ReactNode } from 'react';

import CategoryLink from './CategoryLink';

import { CategoryLinkType } from '../../../types/guides';

type Props = {
  links: CategoryLinkType[];
};

const SubcategoryNavigation = ({ links }: Props): JSX.Element => {
  const subcategoryLinks: ReactNode[] = [];

  for (let i = 0; i < links.length; i++) {
    subcategoryLinks.push(
      <CategoryLink link={links[i]} isSubcategoryLink key={i} />,
    );
  }

  return (
    <div className="overflow-x-auto whitespace-nowrap p-3 text-center">
      {subcategoryLinks}
    </div>
  );
};

export default SubcategoryNavigation;
